<template>
    <div
        :class="{
            'map-round': round,
            'map-focused': focused,
            'map-error': error,
            'map-success': !error && touched,
            'map-expanded': expanded,
            'map-dark': dark,
            'has-label': label,
            'has-icon': has_icon,
            'map-mode-tags': mode === 'tags',
        }"
        class="map-input map-dropdown"
        >
        <slot name="label">
            <label v-if="label">{{ label }}</label>
        </slot>
        <div class="map-input-inner">
            <Multiselect
                :placeholder="placeholder"
                v-bind="$attrs"
                v-model="value"
                :mode="mode"
                :searchable="true"
                :options="options"
            >
                <template v-slot:caret>
                    <i class="map-dropdown-icon icon-chevron-down"></i>
                </template>
            </Multiselect>
        </div>
        <slot name="error" v-if="error || $slots.error">
            <p class="map-error">{{ error }}</p>
        </slot>
    </div>
</template>

<script>
    import Multiselect from '@vueform/multiselect'

    export default
    {
        name: 'dropdown',
        inheritAttrs: false,
        components:
        {
            Multiselect,
        },
        props:
        {
            label: String,
            required: Boolean,
            round: Boolean,
            dark: Boolean,
            placeholder: String,
            modelValue: {required: !1},
            mode: String,
            options:
            {
                type: Array,
                required: true,
                default: () => [],
            },
            error:
            {
                type: String,
                default: ''
            },
            iconLeft: String,
        },
        emits: ['update:modelValue'],
        data()
        {
            return {
                selected: false,
                focused: false,
                touched: false,
                expanded: false,
            };
        },
        computed:
        {
            value:
            {
                get()
                {
                    return this.modelValue;
                },
                set(value)
                {
                    this.$emit('update:modelValue', value);
                },
            },

            has_icon()
            {
                const { iconLeft } = this.$slots;

                return (
                    iconLeft !== undefined ||
                    this.iconLeft !== undefined
                );
            },
        },
        methods:
        {
        }
    }
</script>
